import React, { useEffect, useState } from "react";
import "../style/navbaruser.css";
import Logo from "../assets/images/logo.png";
import { useNavigate } from "react-router-dom";

const NavbarCust = ({ location, isMobile }) => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [openedMenu, setOpenedMenu] = useState(false);

  const handleNavigate = (address) => {
    navigate(address);
  };

  const handleNavigateMobile = (address) => {
    setOpenedMenu(!openedMenu);
    navigate(address);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 80) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`${scrolled ? (location.pathname === "/about" || location.pathname === "/programs" || location.pathname === "/contactus" || location.pathname === "/alumni" || location.pathname === "/scholarshipinfo" ? "custom-con-navUser-white" : "custom-con-navUser-dark") : `custom-con-navUser${location.pathname === "/" || location.pathname === "/courses" ? " nav-over-hero" : ""}`} d-flex justify-content-center align-items-center position-fixed top-0 start-0`}
    >
      <div
        className={
          isMobile
            ? "custom-pos-content position-relative d-flex"
            : "custom-pos-content position-relative"
        }
      >
        {isMobile ? (
          <i
            className="bi bi-list custom-list-logo"
            onClick={() => setOpenedMenu(!openedMenu)}
          ></i>
        ) : (
          <></>
        )}

        <div
          className="custom-con-logo d-flex justify-content-start align-items-start"
          onClick={() => handleNavigate("/")}
        >
          <img
            src={Logo}
            alt="CEAlogo.png"
            className="adjust-photo-logo object-fit-scale"
          />
        </div>
        {isMobile ? (
          <div
            className={`custom-con-menu-mobile ${openedMenu ? "show-position" : "hidden-position"} position-fixed top-0 start-0`}
          >
            <i
              className="bi bi-x-lg custom-close-icon-menu position-absolute top-0 end-0"
              onClick={() => setOpenedMenu(!openedMenu)}
            ></i>
            <div className="text-center position-absolute top-50 start-50 translate-middle">
              <p
                className="custom-text-menu-hamburger"
                onClick={() => handleNavigateMobile("/")}
              >
                HOME
              </p>
              <p
                className="custom-text-menu-hamburger"
                onClick={() => handleNavigateMobile("/about")}
              >
                ABOUT
              </p>
              <p
                className="custom-text-menu-hamburger"
                onClick={() => handleNavigateMobile("/courses")}
              >
                COURSES
              </p>
              <p
                className="custom-text-menu-hamburger"
                onClick={() => handleNavigateMobile("/programs")}
              >
                PROGRAMS
              </p>
              <p
                className="custom-text-menu-hamburger"
                onClick={() => handleNavigateMobile("/scholarshipinfo")}
              >
                SCHOLARSHIP
              </p>
              <p
                className="custom-text-menu-hamburger"
                onClick={() => handleNavigateMobile("/alumni")}
              >
                ALUMNI
              </p>
              <p
                className="custom-text-menu-hamburger"
                onClick={() => handleNavigateMobile("/contactus")}
              >
                CONTACT
              </p>
            </div>
          </div>
        ) : (
          <div className="position-absolute top-50 start-50 translate-middle d-flex justify-content-center text-center">
            <p
              className={
                location.pathname === "/"
                  ? "text-nav-active"
                  : location.pathname === "/courses"
                    ? "custom-text-nav-white"
                    : "custom-text-nav"
              }
              onClick={() => handleNavigate("/")}
            >
              HOME
            </p>
            <p
              className={
                location.pathname === "/about"
                  ? "text-nav-active"
                  : location.pathname === "/" ||
                      location.pathname === "/courses"
                    ? "custom-text-nav-white"
                    : "custom-text-nav"
              }
              onClick={() => handleNavigate("/about")}
            >
              ABOUT
            </p>
            <p
              className={
                location.pathname === "/courses"
                  ? "text-nav-active"
                  : location.pathname === "/"
                    ? "custom-text-nav-white"
                    : "custom-text-nav"
              }
              onClick={() => handleNavigate("/courses")}
            >
              COURSES
            </p>
            <p
              className={
                location.pathname === "/programs"
                  ? "text-nav-active"
                  : location.pathname === "/" ||
                      location.pathname === "/courses"
                    ? "custom-text-nav-white"
                    : "custom-text-nav"
              }
              onClick={() => handleNavigate("/programs")}
            >
              PROGRAMS
            </p>
            <p
              className={
                location.pathname === "/scholarshipinfo"
                  ? "text-nav-active"
                  : location.pathname === "/" ||
                      location.pathname === "/courses"
                    ? "custom-text-nav-white"
                    : "custom-text-nav"
              }
              onClick={() => handleNavigate("/scholarshipinfo")}
            >
              SCHOLARSHIP
            </p>
            <p
              className={
                location.pathname === "/alumni"
                  ? "text-nav-active"
                  : location.pathname === "/" ||
                      location.pathname === "/courses"
                    ? "custom-text-nav-white"
                    : "custom-text-nav"
              }
              onClick={() => handleNavigate("/alumni")}
            >
              ALUMNI
            </p>
            <p
              className={
                location.pathname === "/contactus"
                  ? "text-nav-active"
                  : location.pathname === "/" ||
                      location.pathname === "/courses"
                    ? "custom-text-nav-white"
                    : "custom-text-nav"
              }
              onClick={() => handleNavigate("/contactus")}
            >
              CONTACT
            </p>
          </div>
        )}

        <a
          href="https://www.instagram.com/cuttingedge.academy/"
          target="_blank"
        >
          <i
            className={`${location.pathname === "/" || location.pathname === "/courses" ? "custom-ig-logo-white" : "custom-ig-logo"} bi bi-instagram position-absolute top-50 end-0 translate-middle-y`}
          ></i>
        </a>
      </div>
    </nav>
  );
};

export default NavbarCust;
